// Every place that finds out a session is no longer valid - an API call
// getting a 401, or ProtectedRoute noticing on navigation that the stored
// token is missing/malformed/past its exp - should end the same way: the
// stale auth data gone from localStorage, not just left behind while the
// user's bounced to sign-in.
export function clearSessionStorage(): void {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('role_id');
  localStorage.removeItem('userId');
  localStorage.removeItem('email');
  localStorage.removeItem('permissions');
  localStorage.removeItem('user');
}

// Used by the HTTP clients (apiClient, httpClient) on a 401 - unlike
// ProtectedRoute, they're not already mid-render with a <Navigate> at hand,
// so this does the redirect itself. Guarded against firing more than once,
// since several requests can 401 at the same moment (e.g. a page that fires
// a few calls right as the token expires) - only the first should navigate.
let redirecting = false;

export function handleSessionExpired(): void {
  if (redirecting) return;
  if (window.location.pathname === '/signin') return;
  redirecting = true;

  clearSessionStorage();
  window.location.href = '/signin';
}
